import { z } from 'zod';

export const formSchema = z.object({
  ma_dc: z.string().min(1, 'Mã địa chỉ không được để trống'),
  ten_dc: z.string().min(1, 'Địa chỉ không được để trống'),
  ten_dc2: z.string().optional(),
  lien_he_gh: z.string().optional(),
  dt_gh: z.string().optional(),
  fax_gh: z.string().optional(),
  ghi_chu: z.string().optional(),
  status: z.coerce.number().optional()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ma_dc: '',
  ten_dc: '',
  ten_dc2: '',
  lien_he_gh: '',
  dt_gh: '',
  fax_gh: '',
  ghi_chu: '',
  status: '1'
} as unknown as FormValues;
